const ufeApi = require('services/api/ufeApi');
const jsUtils = require('utils/javascript');
const urlUtils = require('utils/Url');
const reservationsApiBase = '/v1/olr/reservations/';

function getReservationByConfNumber(token, params) {
    const sdnDomain = Sephora.configurationSettings.sdnDomainBaseUrl;
    let url;
    if (params.confirmationNumber) {
        url = `${sdnDomain}${reservationsApiBase}${params.confirmationNumber}`;
        delete params.confirmationNumber;
    }
    url += urlUtils.buildQuery(jsUtils.buildMap(params));

    return ufeApi.makeRequest(url, {
        method: 'GET',
        headers: { 'Authorization': 'Bearer ' + token },
        mode: 'cors',
        credentials: 'omit'
    })
        .then(data => data.errorCode ? Promise.reject(data) : data);
}

module.exports = getReservationByConfNumber;
